import { HubHookFormDragTable, InputLabel } from "../../components";
import WaxTableRow from "./WaxTableRow";

import { keys } from "./helper";
import { StyledStack } from "./styles";

export const WaxRoutingTable = ({
  basePath,
  fields = [],
  remove = () => {},
  move = () => {},
  getFieldProps = () => ({}),
  handleStationChange = () => {},
}) => {
  const props = {
    id: "WaxTable",
    fields,
    keys,
    baseProps: {
      basePath,
      remove,
      getFieldProps,
      handleStationChange,
    },
    RenderRow: WaxTableRow,
    Header: () => (
      <StyledStack
        sx={{
          backgroundColor: "hubColors.greyLighter",
          padding: "8px 2px 8px 10px",
        }}
      >
        {keys?.map((cell) => (
          <InputLabel
            key={cell.id}
            label={cell.label}
            required={cell.required}
            marginBottom="0px"
            sx={{ textAlign: cell.center ? "center" : "start" }}
          />
        ))}
      </StyledStack>
    ),
    move,
  };
  return <HubHookFormDragTable {...props} />;
};

export default WaxRoutingTable;
